module.exports = "//d274d294w9cx2v.cloudfront.net/2dfe6425ef0d52b5bf7594c630b4dfee4100cfe5/images/photo-single.png";